import * as React from "react";
import classnames from "classnames";
import { Modal } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { useTryInStore } from "../../../../hooks/hooks/use-try-in-store.js";
import { AddProduct } from "../../components/modules/SelectionModal/components/AddProduct.js";
import { Footer } from "../../components/modules/SelectionModal/components/Footer.js";
import { ProductItemContainer } from "../../components/modules/SelectionModal/components/ProductItemContainer.js";
import { ProductList } from "../../components/modules/SelectionModal/components/ProductList.js";
/* empty css                    */
const SelectionModal = ({ className, ...rest }) => {
  const { getLabel } = useIntl();
  const [{ products }, { fetchProducts, storage }] = useTryInStore();
  const skus = products?.map((product) => product.sku) ?? [];
  React.useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      isFullScreen: true,
      isOpen: true,
      ...rest,
      className: classnames("try-in-store-selection-modal", className),
      title: getLabel("tryInStore.component.selectionModal.title"),
      titleVariant: "subheading2",
      showIcon: true,
      footer: products?.length ? /* @__PURE__ */ React.createElement(Footer, { skus }) : null
    },
    /* @__PURE__ */ React.createElement("div", { className: "try-in-store-selection-modal__container" }, /* @__PURE__ */ React.createElement(Heading, { component: "h3", variant: "small" }, getLabel("tryInStore.component.selectionModal.title")), /* @__PURE__ */ React.createElement(Text, null, getLabel("tryInStore.component.selectionModal.introduction")), products?.length ? /* @__PURE__ */ React.createElement(ProductList, null, products.map((product) => {
      return /* @__PURE__ */ React.createElement(
        ProductItemContainer,
        {
          key: product.sku,
          product,
          onRemove: storage.remove
        }
      );
    })) : null, !products?.length || products.length < 3 ? /* @__PURE__ */ React.createElement(AddProduct, null) : null, /* @__PURE__ */ React.createElement(Text, { color: "text-secondary", variant: "caption" }, getLabel("tryInStore.component.selectionModal.disclaimer")))
  );
};
export {
  SelectionModal
};
//# sourceMappingURL=SelectionModal.js.map
